import { MouseEvent } from "react";
import ShowMoreText from "react-show-more-text";
import { useDispatch, useSelector } from "react-redux";
import { CustomSelect } from "common.ui/Components/customReactSelect/customSelect";
import { IStore, IServiceStepInfo } from "../../DataTypes/storeTypes";
import { selectService, selectServiceCategory } from "../../Actions/serviceActions";
import { amountToCurrency } from "../../../Common/localeHelper";
import { Button } from "@powerdiary/components-library/lib";

export const Service = () => {
    const dispatch = useDispatch();

    const { servicesData, selectedServiceId, selectedCategory, currencySymbol } = useSelector((state: IStore) => {
        const info = state.stepsInfo[state.common.currentStep] as IServiceStepInfo;
        const settings = state.initialSettings.accountInitialSettings.organisationInfo;

        return {
            servicesData: state.servicesData,
            selectedServiceId: info.id,
            selectedCategory: info.selectedCategory,
            currencySymbol: settings.currencySymbol,
        };
    });

    const handleClick = (e: MouseEvent<any>) => {
        if (e.target && $(e.target).hasClass("link-show-more")) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }
    };

    const priceAndDesc = (amount?: number, desc?: string) => {
        let comps = [];

        if (amount) {
            const formatted = amountToCurrency(amount, currencySymbol);
            comps.push(
                <b key="amount" className="text-gray">
                    {formatted}
                </b>
            );
        }

        if (desc) {
            comps.push(
                <div key="desc">
                    <ShowMoreText lines={2} keepNewLines={true} anchorClass="link-show-more">
                        {desc}
                    </ShowMoreText>
                </div>
            );
        }

        return comps;
    };

    const selectOptions = servicesData.saleableCategories.map((c) => {
        return {
            value: c.item1,
            label: c.item2,
        };
    });

    const selected = selectedCategory ? selectOptions.find((o) => o.value === selectedCategory) : selectOptions[0];

    const services = servicesData.services
        .filter((s) => !selectedCategory || parseInt(selectedCategory) === s.saleableCategoryId)
        .map((s) => {
            const isSelected = selectedServiceId === s.id;

            return (
                <div
                    key={s.id}
                    className={`big-btn service-big-btn ${isSelected ? "selected" : ""}`}
                    onClick={() => dispatch(selectService(s.id))}
                >
                    <div className="d-block w-100">
                        <div className="row align-items-center">
                            <div className="col col-md-9 pr-md-0">
                                <span className="service-name">{s.name}</span>

                                <small className="service-description" onClick={handleClick}>
                                    {priceAndDesc(s.amount, s.description)}
                                </small>
                            </div>

                            <div className="col-3 pl-0">
                                <Button variant="outlined" size="small" className="float-right">
                                    {s.duration} MIN
                                </Button>
                            </div>
                        </div>
                    </div>

                    {isSelected && <i className="fa fa-check" />}
                </div>
            );
        });

    return (
        <div className="row">
            <div className="col-sm-12 col-lg-11 ml-auto mr-auto">
                {servicesData.saleableCategories.length > 1 && (
                    <div className="row align-items-center mb-3">
                        <div className="col-auto pr-0">
                            <label className="mb-0">Filter by Category</label>
                        </div>
                        <div className="col-lg-5 col-xl-4 col">
                            <CustomSelect
                                value={selected}
                                options={selectOptions}
                                onChange={(selected) => dispatch(selectServiceCategory((selected as any).value))}
                            />
                        </div>
                    </div>
                )}

                {services}
            </div>
        </div>
    );
};
